import { Component, Input, Output, OnInit } from '@angular/core';
import { Assessor } from 'src/app/models/Assessor';

@Component({
  selector: 'app-assessors-details',
  templateUrl: 'assessors-details.component.html',
  styleUrls: ['./assessors-details.component.less', '../../../shared/common.less'],
})

export class AssessorsDetailsComponent implements OnInit {
  @Input() isValidated: boolean = false;
  @Input() assessors: Array<Assessor> = []
  isExpanded: boolean = true;

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  ngOnInit(): void {
  }
}
